module.exports = __webpack_public_path__ + "images/67246b89c228fafba662a780b23d41fe-logo.png";